var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_wrap"},[_c('van-nav-bar',{attrs:{"safe-area-inset-top":"","fixed":"","left-arrow":"","title":_vm.$t('lang.会员等级')},on:{"click-left":function($event){return _vm.$router.back()}}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }